import { transport } from 'config/transport';

export function callApiUpdateNun(congDoanId, nunId, body) {
    return transport.put(`/congdoan/${congDoanId}/nun/${nunId}`, body);
}
